import React from "react";
import Autopara from "../Autopara/Autopara";

const images = [
  "https://img.freepik.com/premium-photo/skills-development-internet-technology-business_220873-3999.jpg",
  "https://media.istockphoto.com/id/1128571392/photo/self-development-motivational-words-quotes-concept.jpg?s=612x612&w=0&k=20&c=UGtd_Udk2a5jc3UiLyvYHlseKwPUZDV2J54d7FLR9Zg=",
  "https://t3.ftcdn.net/jpg/02/85/23/92/360_F_285239244_T7aYybMMlrGaZBM1HraToiUSJEGah9e0.jpg",
];

const paragraphText = `
  <strong>Skill Development Programs</strong> focus on 
  personality development, leadership, and problem-solving.<br/><br/>
  Students learn <em>teamwork, adaptability, and critical thinking</em>, 
  making them <span style="color: teal; font-weight: bold;">job-ready</span> 
  for multiple industries.
`;

function AutoparaSkillDevelopment() {
  return <Autopara images={images} text={paragraphText} />;
}

export default AutoparaSkillDevelopment;
